import Api from '@api/contentCenter'
import { isWeddingDressPhotoProperty } from '@merchant-backend/util'
import {
  Button,
  Col,
  Form,
  MagicInput,
  message,
  Modal,
  Row,
  Upload
} from 'hljd'
import { isHotelMerchant } from '@util'
import React, { useState } from 'react'
import AddTags from './AddTags'
import {
  IMAGE_MAX_SIZE,
  IMAGE_TYPE,
  SUBMIT_MEDIA_HYBRID,
  SUBMIT_MEDIA_ONLY_IMAGE,
  SUBMIT_MEDIA_ONLY_VIDEO,
  VIDEO_DURATION,
  VIDEO_MAX_SIZE,
  VIDEO_TYPE
} from './constants'
import Emoji from './Emoji'
import HotelHallModal from './HotelHallModal'
import style from './style.module.less'

const { Item } = Form

const Publish = ({ topicId, store }) => {
  const [form] = Form.useForm()
  const [submitLoading, setSubmitLoading] = useState(false)
  const [maxImages, setMaxImages] = useState(9)
  const [videoShow, setVideoShow] = useState(true)

  const handleSubmit = () => {
    form
      .validateFields()
      .then(res => {
        const data = formatData(res)
        submitData(data)
      })
      .catch(err => {
        console.error(err)
      })
  }

  const submitData = async values => {
    setSubmitLoading(true)
    const { success } = await Api.publishNote(values)
    if (success) {
      message.success('发布成功')
      store.getNoteList()
      form.resetFields()
    }
    setSubmitLoading(false)
  }

  const formatImages = imgs =>
    imgs?.map(i => ({
      media: {
        photo: {
          image_path: i.url,
          height: i.height,
          width: i.width
        },
        type: IMAGE_TYPE
      },
      spots: []
    }))

  const formatVideo = videos =>
    videos?.map(v => ({
      media: {
        video: {
          cover_path: v.url + `?vframe/png/offset/0/w/${v.width}/h/${v.height}`,
          height: v.height,
          width: v.width,
          origin_path: v.url,
          persistent_id: v.response.persistent_id
        },
        type: VIDEO_TYPE
      }
    }))

  const formatMarks = marks => {
    if (!marks) {
      return
    }
    let newMarks = []
    Object.keys(marks)
      .map(k => marks[k])
      .filter(f => f)
      .forEach(e => {
        newMarks = newMarks.concat(e)
      })
    return newMarks.map(e => ({
      id: e.value,
      name: e.name
    }))
  }

  const formatNoteType = inspirations => {
    const existVideo =
      inspirations.findIndex(f => f.media?.type === VIDEO_TYPE) > -1
    const existImgs =
      inspirations.findIndex(f => f.media?.type === IMAGE_TYPE) > -1
    if (existVideo && existImgs) {
      return SUBMIT_MEDIA_HYBRID
    }
    if (existImgs && !existVideo) {
      return SUBMIT_MEDIA_ONLY_IMAGE
    }
    if (existVideo && !existImgs) {
      return SUBMIT_MEDIA_ONLY_VIDEO
    }
  }

  const formatData = data => {
    // 处理图片，合并视频
    let inspirations = formatImages(data.imgs)
      .concat(formatVideo(data.videos))
      .filter(Boolean)
    const values = {
      title: data.title,
      content: data.content,
      note_book_type: '4',
      note_type: formatNoteType(inspirations),
      marks: formatMarks(data.marks),
      inspirations,
      hotel_hall_id: data.hotel_hall_id,
      note_topic_id: topicId
    }
    return values
  }

  const handleImgBefore = file => {
    const size = file.size / 1024 / 1024 // Mb
    if (size > IMAGE_MAX_SIZE) {
      Modal.warning({ title: `图片大小不能超过${IMAGE_MAX_SIZE}M` })
      return Promise.reject()
    }
  }

  const handleVideoBefore = async file => {
    const duration = await Upload.checkDurationSync(file)
    const size = file.size / 1024 / 1024 // Mb
    if (size > VIDEO_MAX_SIZE) {
      Modal.warning({ title: `视频大小不能超过${VIDEO_MAX_SIZE}M` })
      return Promise.reject()
    }
    if (duration > VIDEO_DURATION) {
      Modal.warning({ title: `视频大小不能超过${VIDEO_DURATION / 60}分钟` })
      return Promise.reject()
    }
    return Promise.resolve(file)
  }

  const fromChangeValue = changeValue => {
    if (!changeValue['videos'] && !changeValue['imgs']) {
      return
    }
    const videos = form.getFieldValue('videos')
    const imgs = form.getFieldValue('imgs')
    if (videos.length) {
      setMaxImages(8)
    } else {
      setMaxImages(9)
    }
    if (imgs.length && imgs.length >= 9) {
      setVideoShow(false)
    } else {
      setVideoShow(true)
    }
  }

  return (
    <div className={style.publish}>
      <Form
        onValuesChange={fromChangeValue}
        colon={false}
        onFinish={handleSubmit}
        form={form}
        labelAlign="right"
      >
        {videoShow && (
          <Item
            className={style.uploadVideo}
            style={{ marginBottom: 24 }}
            label="上传视频"
            name="videos"
            dependencies={['imgs']}
            initialValue={[]}
            rules={[
              {
                validator: (rule, value) => {
                  const length = form.getFieldValue('imgs').length
                  if (!length && !value.length) {
                    return Promise.reject('图片和视频至少上传一项')
                  }
                  return Promise.resolve()
                }
              }
            ]}
          >
            <Upload
              height={180}
              width={288}
              accept="video/*"
              beforeUpload={handleVideoBefore}
              upText="上传视频"
              max={1}
            />
          </Item>
        )}
        <Item
          className={style.uploadImage}
          style={{ marginBottom: 12 }}
          required={false}
          label="上传图片"
          name="imgs"
          dependencies={['videos']}
          rules={[
            {
              validator: (rule, value) => {
                const length = form.getFieldValue('videos').length
                if (!length && !value.length) {
                  return Promise.reject('图片和视频至少上传一项')
                }
                return Promise.resolve()
              }
            }
          ]}
          initialValue={[]}
        >
          <Upload
            beforeUpload={handleImgBefore}
            sortable
            height={180}
            width={180}
            max={maxImages}
            multiple
          />
        </Item>
        <Item
          className={style.input}
          style={{ marginBottom: 10 }}
          name="title"
          initialValue={''}
          label=""
          rules={[
            {
              required: true,
              message: '请输入您的标题'
            },
            {
              type: 'string',
              max: 18,
              message: '标题不能超过18个字'
            }
          ]}
        >
          <MagicInput
            size="large"
            maxLength={18}
            showCount
            placeholder="拟个标题，脱颖而出"
            countPosition="inner"
          />
        </Item>
        <Item
          style={{ marginBottom: 20 }}
          name="content"
          label=""
          initialValue={''}
          rules={[
            { required: true, message: '请输入您的正文' },
            {
              type: 'string',
              max: 2000,
              message: '正文不能超过2000个字'
            }
          ]}
        >
          <MagicInput.TextArea
            rows={6}
            showCount
            placeholder="分享你的工作现场、婚礼灵感或优质案例吧，备婚新人会更关注婚礼人的动态哦"
            countPosition="inner"
            maxLength={2000}
          />
        </Item>
        <Row gutter={30}>
          <Col>
            <Emoji
              getFieldValue={form.getFieldValue}
              setFieldsValue={({ content }) => {
                if (content.length > 2000) {
                  return
                } else {
                  form.setFieldsValue({
                    content
                  })
                }
              }}
            />
          </Col>
          {isWeddingDressPhotoProperty() && (
            <Col>
              <Item style={{ marginBottom: 0 }} label="" name="marks">
                <AddTags />
              </Item>
            </Col>
          )}
          {isHotelMerchant() && (
            <Col>
              <Item style={{ marginBottom: 0 }} label="" name="hotel_hall_id">
                <HotelHallModal />
              </Item>
            </Col>
          )}

          <Col flex={'1 1 auto'}>
            <Button
              htmlType="submit"
              style={{ float: 'right' }}
              type="primary"
              loading={submitLoading}
            >
              发布动态
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  )
}

export default Publish
